export {
  MAX_DIGITAL_CARD_AMOUNT,
  MAX_PHYSICAL_CARD_AMOUNT,
  MIN_DIGITAL_CARD_AMOUNT,
  MIN_PHYSICAL_CARD_AMOUNT,
  MAX_CORPORATE_CARD_AMOUNT,
  MIN_CORPORATE_CARD_AMOUNT,
  MAX_CORPORATE_CARD_TOTAL_AMOUNT,
  MAX_CORPORATE_CARD_QUANTITY,
  MIN_CORPORATE_CARD_QUANTITY,
  MIN_CORPORATE_CARD_TOTAL_AMOUNT
};

const max_gift_card_amount = 9999.99;
const min_gift_card_amount = 10.0;

const MAX_DIGITAL_CARD_AMOUNT = max_gift_card_amount;
const MAX_PHYSICAL_CARD_AMOUNT = max_gift_card_amount;
const MAX_CORPORATE_CARD_AMOUNT = max_gift_card_amount;
const MAX_CORPORATE_CARD_TOTAL_AMOUNT = max_gift_card_amount;
const MIN_CORPORATE_CARD_TOTAL_AMOUNT = min_gift_card_amount;
const MIN_DIGITAL_CARD_AMOUNT = min_gift_card_amount;
const MIN_PHYSICAL_CARD_AMOUNT = min_gift_card_amount;
const MIN_CORPORATE_CARD_AMOUNT = min_gift_card_amount;
const MAX_CORPORATE_CARD_QUANTITY = 1000;
const MIN_CORPORATE_CARD_QUANTITY = 1;
